<div
(click)="params.wmlOptionItem?.clickPredicate?.($any(params.wmlOptionItem))"
[class]="classPrefix('MainPod') + ' '+ params.wmlOptionItem?.class">
  <div [class]="classPrefix('MainItem0')" [style]="params.color.style"></div>
</div>
